import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

let lenisInstance = null;
export const getLenis = () => lenisInstance;

export function SmoothScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); lenisInstance = null; };
  }, []);

  useEffect(() => {
    const lenis = lenisInstance;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { setTimeout(() => (lenis ? lenis.scrollTo(el, { offset: -90 }) : el.scrollIntoView()), 150); return; }
    }
    if (lenis) lenis.scrollTo(0, { immediate: true }); else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
